<template>
 <div class="footer-subscribe" v-show="modalVisibility">
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">
          <div class="modal-body">
            <div class="image-details row">
              <div class="col-md-6 col-sm-12">
                  <div>
                    <input id="optin" type="checkbox" v-model="checkbox" />
                    <small><label for="opitn">I want to receive marketing communication from Rhino-Rack. You can opt-out at any time.</label></small>
                  </div>
                 <vue-recaptcha
                    :sitekey="sitekey"
                    :loadRecaptchaScript="true"
                    @error="error"
                    @expired="expired"
                    @verify="verify"
                ></vue-recaptcha>
              </div>
              <div class="col-md-5 col-sm-12" style="text-align: right;">
                <button class="btn btn-hover pull-right btn-primary" @click="sendRequest()" style="height: 50px; width: 150px;" :disabled="(verified && !clicked) ? false : true"> Submit</button>
                <br>
                <span style="color: rgb(0, 92, 185); float: right; font-weight: 700; font-size: smaller;">{{ message }}</span>
              </div>
              <div class="col-md-1" style="max-width: 0px;padding: 0px;">
                <span class="modal-close" @click="hideModal">&times;</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</div>
</template>
<script>
import VueRecaptcha from "vue-recaptcha";

export default {
  name: "out-of-stock-recaptcha-modal",
  components: { VueRecaptcha: VueRecaptcha },
  data() {
    return {
      verified: false,
      verified_token: "",
      message : "",
      clicked : false,
      checkbox: false,
    };
  },
  props: {
    sitekey: {
      type: String,
      required: true
    }
  },
  methods: {
    expired(value) {
      this.verified = false;
    },
    verify(value) {
      this.verified_token = value;
      this.verified = true;
    },
    error(value) {
      this.verified = false;
    },
    sendRequest(){
      this.$store.commit('outofstock/hideModal');
      this.$store.dispatch('outofstock/sendRequest', { optIn: this.checkbox });
    },
    showModal() {
        this.$store.commit('outofstock/showModal');
    },
    hideModal() {
        this.$store.commit('outofstock/hideModal');
    },
  },
  computed: {
    modalVisibility() {
        return this.$store.getters['outofstock/modalVisibility'];
    }
  }
}
</script>

<style scoped>
  input[type=checkbox] {
    height: 1.5rem;
    width: 1.5rem;
  }

  label {
    display: inline;
  }
</style>